import { render, staticRenderFns } from "./addOrderDiscount.vue?vue&type=template&id=2069af54&"
import script from "./addOrderDiscount.vue?vue&type=script&lang=js&"
export * from "./addOrderDiscount.vue?vue&type=script&lang=js&"
import style0 from "./addOrderDiscount.vue?vue&type=style&index=0&id=2069af54&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports